import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { CohortsView } from "@/features/academy/components/cohorts-view";

export const academyCohortsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/academy/cohorts",
  component: CohortsView,
});
